import { z } from "zod"

import { CapabilityExecutionStatus, CapabilityIdentifier } from "../../capabilities/dtos"
import { CapabilityReasonSchema } from "../../capabilities/reasons"
import { PaginationSchema } from "../../shared/pagination_dtos"

export const BackofficeCapabilityExecutionsMinDateISOString = "2026-02-03T00:00:00.000Z"
export const BackofficeCapabilityExecutionsDefaultRangeDays = 7
export const BackofficeCapabilityExecutionsDefaultCapabilities = Object.values(
  CapabilityIdentifier,
).filter((identifier) => identifier !== CapabilityIdentifier.Support)
export const BackofficeCapabilityExecutionsMaxRangeDays = 30

export const BackofficeCapabilityExecutionProviderEnum = [
  "Shopify",
  "BigBlue",
  "Amphora",
  "Reveni",
  "LoopReturns",
  "Rever",
] as const

export const BackofficeCapabilityExecutionActionEnum = [
  "shipping_address",
  "delivery_priority",
  "on_hold",
  "line_item",
] as const

export const BackofficeCapabilityExecutionsSearchSchema = PaginationSchema.extend({
  companyId: z.string().optional(),
  experiment: z.string().min(1).optional(),
  from: z.string(),
  activityFrom: z.string().optional(),
  to: z.string(),
  status: z.enum(["all", ...Object.values(CapabilityExecutionStatus)] as const).optional(),
  reason: z.union([z.literal("all"), CapabilityReasonSchema]).optional(),
  provider: z.string().optional(),
  capabilityIdentifier: z
    .string()
    .default(BackofficeCapabilityExecutionsDefaultCapabilities.join(",")),
  action: z.enum(BackofficeCapabilityExecutionActionEnum).optional(),
})

export const BackofficeCapabilityExecutionsStatusEnum = [
  ...Object.values(CapabilityExecutionStatus),
] as const

export const BackofficeCapabilityExecutionsReasonFilterEnum = z.union([
  z.literal("all"),
  CapabilityReasonSchema,
])

export const BackofficeCapabilityExecutionsCapabilityIdentifierEnum = z.enum(
  Object.values(CapabilityIdentifier) as [string, ...string[]],
)
